import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Alert from 'react-bootstrap/Alert';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { PulseLoader } from 'react-spinners';
import { trackPromise } from 'react-promise-tracker';
import ActionPopup from '../../../../../src/components/action-panel-modal/action-panel';
import PlaceholderEmptyScreen from "../../../../../src/components/PlaceholderEmptyScreen";
import { GetBlankDepartmentQuery, GetAllDepartmentsAPI } from '../../../../services/api/department-api';
import { GetAllRolesForDepartment } from '../../../../services/api/role-api';
import { EditRolePrivilege, GetRolePrivilege, FixRolePrivileges} from '../../../../services/api/role-privilege-api';
import { LoginContext } from '../../../../services/api/authentication-api';
import Dropdown from '../../../../components/dropdown-main/DropdownMain';
import SuccessIcon from '../../../../../src/assets/img/success-icon.svg';
import WarningIcon from '../../../../../src/assets/img/Icon - Warning.svg';
import placeholderImage from "../../../../../src/assets/img/no-project-template.svg";
import './admin-role-privilege-page.scss';

class AdminRolePrivilegePage extends React.Component{
    constructor(Props){
        super(Props);

        this.state = {
            searchQuery: {},
            departments: [],
            subdepartments: [],
            rolePrivilege: undefined,
            rolePrivilege1: undefined,
            roles: [],
            currDepartment: undefined,
            currSubDepartment: undefined,
            currRole: undefined,
            isRoleAdmin: undefined,
            isRoleSuperAdmin: undefined,
            tasksSubTabOpen: false,
            projectsSubTabOpen: false,
            adminSubTabOpen: false,
            notificationSubTabOpen: false,
            showAlert: false,
            alertAction: "",
            alertMessage: "",
            alertVariant: "danger",
            isDepartmentSelected: false,
            isSubDepartmentSelected: false,
            isSubmitting: false,
            showSuccessPopup: false,
            showCancelPopup: false,
            loaded:false,
            num:0,

            //Checkmarks -> -1: none selected, 0: at least one selected, 1: all selected
            columns: {
                View: -1,
                Edit: -1,
                Add: -1,
                Delete: -1,
                Detail: -1,
            },

            topics: {
                View: {
                    Home: -1,
                    Project: -1,
                    Admin: -1,
                    Notifications: -1
                },
                Edit: {
                    Home: -1,
                    Project: -1,
                    Admin: -1,
                    Notifications: -1
                },
                Add: {
                    Home: -1,
                    Project: -1,
                    Admin: -1,
                    Notifications: -1
                },
                Delete: {
                    Home: -1,
                    Project: -1,
                    Admin: -1,
                    Notifications: -1
                },
                Detail: {
                    Home: -1,
                    Project: -1,
                    Admin: -1,
                    Notifications: -1
                },
            }
        }
    }

    componentDidMount = () => {
        trackPromise(
            GetBlankDepartmentQuery().then(
                (searchQuery) => {
                    searchQuery.pageSize = 100000;
                    this.setState({
                        searchQuery: searchQuery
                    });
                    GetAllDepartmentsAPI({ ...this.state.searchQuery, pageNumber: 1, sortDesc: false, sortBy: "Name", pageSize: 100000, filters: [] }).then(
                        (result) => {
                            this.setState({
                                departments: result?.data?.dataList,
                            });
                            if (result?.data?.dataList && !this.props.currentUser?.isSuperAdminRole) {
                                const userDepartment = result?.data?.dataList?.find((company) => {return company.Id === this.props.currentUser.company});
                                this.changeDepartment({
                                    id: userDepartment.Id, name: userDepartment.Name + (userDepartment.Active ? "" : " [Inactive]"), disabled: !userDepartment.Active
                                });
                            }
                        },
                        (error) => {
                            this.setState({
                                showAlert: true,
                                alertAction: "Cannot Get Departments",
                                alertMessage: error.toString(),
                                alertVariant: "danger",
                             });
                        }
                    )
                }
            ), "admin-role-dropdowns-overlay"
        )
    }

    getSubItems = (header, topic) => {
        const viewProjectList = ["Projects", "Completed Projects", "Archived Projects"];
        this.state.isRoleAdmin && viewProjectList.push("Projects within department");
        const includeSubDepartment = this.doesSubDepartmentExist();
        const itemData = {
                View: {
                    Home: ["Document Collaboration", "Task Management"],
                    Project: viewProjectList,
                    Admin: ["User", "Group", "Role", "Role Privileges", "Department", ...(includeSubDepartment ? ["Sub-Department"] : []), "Log Activity","Email Notifications", "Platform Notifications", "Templates", "Task Types"],
                    Notifications: ["Email Notifications", "Platform Notifications"]
                },
                Edit: {
                    Home: ["Document Collaboration", "Task Management"],
                    Project: ["Projects", "Completed Projects", "Archived Projects"],
                    Admin: ["User", "Group", "Role", "Role Privileges", "Department", ...(includeSubDepartment ? ["Sub-Department"] : []), "Email Notifications", "Platform Notifications", "Templates", "Task Types"],
                    Notifications: ["Email Notifications", "Platform Notifications"]
                },
                Add: {
                    Home: ["Document Collaboration", "Task Management"],
                    Project: ["Projects", "Completed Projects", "Archived Projects"],
                    Admin: ["User", "Group", "Role", "Department", ...(includeSubDepartment ? ["Sub-Department"] : []), "Templates", "Task Types"],
                    Notifications: []
                },
                Delete: {
                    Home: [],
                    Project: ["Projects", "Completed Projects", "Archived Projects"],
                    Admin: ["User", "Group", "Role", "Department", ...(includeSubDepartment ? ["Sub-Department"] : []), "Templates", "Task Types"],
                    Notifications: []
                },
                Detail: {
                    Home: [],
                    Project: ["Projects", "Completed Projects", "Archived Projects"],
                    Admin: ["User", "Group", "Role", "Department", ...(includeSubDepartment ? ["Sub-Department"] : []), "Log Activity", "Templates", "Task Types"],
                    Notifications: []
                },
        }

        if (!itemData.hasOwnProperty(header) || !(itemData[header].hasOwnProperty(topic))) return [];
        return itemData[header][topic];
    }

    getIndividualRows =(header) => {
        switch (header) {
            case "View":
                if (this.state.rolePrivilege1['Search'] !== undefined) return ['Dashboard', 'Search', 'Updated Document'];
                else return ['Dashboard', 'Updated Document'];
            default:
                return [];
        }
    }

    getSubHeaders = (header) => {
        const allTopics = ['Home', 'Project', 'Admin', 'Notifications'];
        let itemsUnderHeader = [];

        itemsUnderHeader = itemsUnderHeader.concat(this.getIndividualRows(header));

        allTopics.forEach((topic) => {
            itemsUnderHeader = itemsUnderHeader.concat(this.getSubItems(header,topic));
        })

        return itemsUnderHeader;
    }

    getAdminStatus = (roleID) => {
        const roleData = this.state.roles.find(role => role.Id === roleID);

        if(!roleData || !roleData.hasOwnProperty('Admin') || roleData.Admin === null) return false;
        return roleData.Admin;
    }

    getSuperAdminStatus = (roleID) => {
        const roleData = this.state.roles.find(role => role.Id === roleID);

        if (!roleData || !roleData.hasOwnProperty('SuperAdmin') || roleData.SuperAdmin === null) return false;
        return roleData.SuperAdmin;
    }

    changeRole = (newRole) => {
        this.getSuperAdminStatus(newRole.id);

        this.setState({
            currRole: newRole,
            isRoleAdmin: this.getAdminStatus(newRole.id),
            isRoleSuperAdmin: this.getSuperAdminStatus(newRole.id),
            rolePrivilege: undefined,
            rolePrivilege1: undefined,
            tasksSubTabOpen: false,
            projectsSubTabOpen: false,
            adminSubTabOpen: false,
            notificationSubTabOpen: false,
        });
        this.loadTableForRole(newRole);
    }

    changeDepartment = (newDepartment) => {
        this.setState({
            roles: [],
            currDepartment: newDepartment,
            currRole: undefined,
            rolePrivilege: undefined,
            rolePrivilege1: undefined,
        });
        this.loadRolesForDepartment(newDepartment);
    }

    loadRolesForDepartment = (newDepartment) => {
        if (newDepartment === undefined) {
            this.setState({isDepartmentSelected: false});
            return;
        }

        this.setState({loaded: true});

        trackPromise(
            GetAllRolesForDepartment(newDepartment.id).then(
                (result) => {
                    if(result.status === 200){
                        this.setState({
                            roles: result?.data,
                            isDepartmentSelected: true,
                            loaded: false
                        });
                    }
                    else{
                        this.setState({
                            showAlert: true,
                            alertAction: "Cannot Get Roles For Departments",
                            alertMessage: result?.response?.data,
                            alertVariant: "danger",
                            loaded: false
                         });
                    }
                },
                (error) => {
                    this.setState({
                        showAlert: true,
                        alertAction: "Cannot Get Roles For Departments",
                        alertMessage: error.toString(),
                        alertVariant: "danger",
                        loaded: false
                     });
                }
            ), "admin-role-dropdowns-overlay"
        )
    }

    loadTableForRole = (newRole) => {
        if(newRole === undefined) return;

        this.setState({loaded:true});

        trackPromise(
            GetRolePrivilege(newRole.id).then(
                (rolePrivilege) => {

                    let rolePrivilege1 = {};
                    for (let i = 0; i < rolePrivilege.length; ++i) {
                        rolePrivilege1[rolePrivilege[i].MenuItem] = rolePrivilege[i];
                    }

                    this.setState({
                        rolePrivilege: rolePrivilege,
                        rolePrivilege1: rolePrivilege1,
                        loaded:false
                    });

                    this.verifyTopic(rolePrivilege1, ['View', 'Edit', 'Add', 'Delete', 'Detail']);
                    this.verifyColumns(rolePrivilege1, ['View', 'Edit', 'Add', 'Delete', 'Detail']);
                },
                (error) => {
                    this.setState({
                        showAlert: true,
                        alertAction: "Cannot Get Role Privilege",
                        alertMessage: error.toString(),
                        alertVariant: "danger",
                        loaded: false
                     });
                }
            ), "admin-role-table-overlay"
        );
    }

    onSubmit = () => {
        let rolePrivilege = [];
        //Disables button if the API response is long
        this.setState({isSubmitting: true, loaded: true});

        Object.keys(this.state.rolePrivilege1).forEach((key, index) => {
            rolePrivilege.push(this.state.rolePrivilege1[key]);
        });

        trackPromise(
            EditRolePrivilege(rolePrivilege).then(
                (result) => {
                    this.setState({
                        showSuccessPopup: true,
                        isSubmitting: false,
                        loaded: false
                    });
                },
                (error) => {
                    this.setState({
                        showAlert: true,
                        alertAction: "Cannot Save Role Privilege",
                        alertMessage: error.toString(),
                        alertVariant: "danger",
                        isSubmitting: false,
                        loaded: false
                     });
                }
            ), "admin-role-table-overlay"
        )
    }

    fixRolePrivileges = ()=> {
        trackPromise(
            FixRolePrivileges().then (
                (result)=>{
                    document.location.reload();
                    console.log(result);
                },
                (error) => {
                    console.log(error);
                }
            ), "admin-role-table-overlay"
        );
    }

    changeSubItems = (rolePrivilege1, header, topic, newItemValue) => {
        const subItems = this.getSubItems(header,topic);

        //Now need to change all the subItem values
        try {
            subItems.forEach((item) => {
                rolePrivilege1[item][header] = newItemValue;
            })
        } catch{
            this.fixRolePrivileges();
        }

        return rolePrivilege1;
    }

    changePermissionColumn = (topic, colIndex) => {
        let rolePrivilege1 = Object.assign({}, this.state.rolePrivilege1);
        const primaryHeader = this.getHeader(colIndex);
        const prevValue = this.state.topics[primaryHeader][topic];
        let newItemValue = false;

        let headersToCheck = [primaryHeader];

        if (prevValue === 0 || prevValue === 1){
            newItemValue = false;
        } else if (prevValue === -1) {
            newItemValue = true;
        }

        rolePrivilege1 = this.changeSubItems(rolePrivilege1, primaryHeader,topic, newItemValue);

        if(colIndex != 0 && newItemValue === true){
            rolePrivilege1 = this.changeSubItems(rolePrivilege1, 'View', topic, true);
            headersToCheck.push('View');
        }

        this.setState({rolePrivilege1: rolePrivilege1});

        this.verifyTopic(rolePrivilege1, headersToCheck);
        this.verifyColumns(rolePrivilege1, headersToCheck);
    }

    // this is for header items
    createPermissionColumn = (MenuItem, subItems, action) => {
        let rolePrivilege1 = Object.assign({}, this.state.rolePrivilege1);

        try {
            rolePrivilege1[MenuItem.name] = {
                RoleID: this.state.currRole.roleID, MenuItemID: MenuItem.id, View: false, Edit: false, Add: false, Delete: false, Detail: false, modifiedBy: this.context.userID
            };

            subItems.forEach((item) => {
                rolePrivilege1[item.name] = {
                    RoleID: this.state.currRole.roleID, MenuItemID: item.id, View: false, Edit: false, Add: false, Delete: false, Detail: false, modifiedBy: this.context.userID
                };
            })

            if (action !== 'View') {
                rolePrivilege1[MenuItem]['View'] = true;
                subItems.forEach((item) => {
                    rolePrivilege1[item.name][action] = true;
                    rolePrivilege1[item.name]['View'] = true;
                })
            } else {
                subItems.forEach((item) => {
                    rolePrivilege1[item.name]['View'] = true;
                })
            }
            rolePrivilege1[MenuItem][action] = true;
        } catch{
            this.fixRolePrivileges();
        }

        //rolePrivilege1 = this.verifyHeaders(MenuItem, rolePrivilege1, action);
        //if (action !== 'view') { rolePrivilege1 = this.verifyHeaders(MenuItem, rolePrivilege1, 'view') };
        this.verifyColumns(rolePrivilege1, [action]);

        this.setState({ rolePrivilege1: rolePrivilege1 });
    }

    // this is for sub items
    createPermissionColumn2 = (headerItem, MenuItem, subItems, action) => {
        let rolePrivilege1 = Object.assign({}, this.state.rolePrivilege1);
        rolePrivilege1[headerItem.name] = {
            RoleID: this.state.currRole.roleID, MenuItemID: headerItem.id, View: false, Edit: false, Add: false, Delete: false, Detail: false, modifiedBy: this.context.userID
        };

        subItems.forEach((item) => {
            rolePrivilege1[item.name] = {
                RoleID: this.state.currRole.roleID, MenuItemID: item.id, View: false, Edit: false, Add: false, Delete: false, Detail: false, modifiedBy: this.context.userID
            };
		});

        try{
            if (action !== 'View') {
                rolePrivilege1[MenuItem]['View'] = true;
            }
            rolePrivilege1[MenuItem][action] = true;
        } catch {
            this.fixRolePrivileges();

        }

        //rolePrivilege1 = this.verifyHeaders(MenuItem, rolePrivilege1, action);
        //if (action !== 'view') { rolePrivilege1 = this.verifyHeaders(MenuItem, rolePrivilege1, 'view') };
        this.verifyColumns(rolePrivilege1, [action]);

        this.setState({ rolePrivilege1: rolePrivilege1 });
	}

    createPermission = (MenuItem, id, colIndex) => {
        let projectSubItems = [
            {name: "Projects", id: 20},
            {name: "Completed Projects", id: 11},
            {name: "Archived Projects", id: 6},
            {name: "Projects within department", id: 25}
        ]
        let taskSubItems = [
            {name: "Standard Task", id: 19},
            {name: "Document Collaboration", id: 18}
        ]
        let adminSubItems = [
            {name: "User", id: 7},
            {name: "Group", id: 24},
            {name: "Role", id: 8},
            {name: "Role Privileges", id: 9},
            {name: "Department", id: 10},
            {name: "Sub-Department", id: 29},
            {name: "Log Activity", id: 12},
            {name: "Notifications", id: 21},
            {name: "Email Notifications", id: 22},
            {name: "Platform Notifications", id: 23},
            {name: "Templates", id: 27},
            {name: "Task Types", id: 28}
        ];
        let notificationSubItems = [
            {name: "Email Notifications", id: 22},
            {name: "Platform Notifications", id: 23}
        ];
        let action = colIndex === 0 ? 'View' : (colIndex === 1 ? 'Edit' : (colIndex === 2 ? 'Add' : (colIndex === 3 ? 'Delete' : 'Detail')));

        if (MenuItem === "Admin") {
            this.createPermissionColumn({name: MenuItem, id: 15}, adminSubItems, action);
        } else if (MenuItem === "Home") {
            this.createPermissionColumn({name: MenuItem, id: 17}, taskSubItems, action);
		} else if (MenuItem === "Notifications") {
            this.createPermissionColumn({name: MenuItem, id: 21}, notificationSubItems, action);
        } else if (MenuItem === "Project") {
            this.createPermissionColumn({name: MenuItem, id: 5}, projectSubItems, action);
		} else if (adminSubItems.includes(MenuItem)) {
            this.createPermissionColumn2({name: "Admin", id: 15}, MenuItem, adminSubItems, action);
		} else {
            let rolePrivilege1 = Object.assign({}, this.state.rolePrivilege1);
            rolePrivilege1[MenuItem] = {
                RoleID: this.state.currRole.roleID,
                MenuItemID: id,
                View: false,
                Edit: false,
                Add: false,
                Delete: false,
                Detail: false,
                modifiedBy: this.context.userID
            };

            try {
                rolePrivilege1[MenuItem][action] = true;
            } catch {
                this.fixRolePrivileges();
            }

            this.verifyColumns(rolePrivilege1, [action]);
            this.setState({ rolePrivilege1: rolePrivilege1 });
        }
    }

    getHeader = (colIndex) => {
        //Will get here if it's one of the subtasks
        switch(colIndex){
            case 0:
                return 'View';
            case 1:
                return 'Edit';
            case 2:
                return 'Add';
            case 3:
                return 'Delete';
            case 4:
                return 'Detail';
            default:
                return "";
        }
    }

    changePermission = (MenuItem, colIndex) => {
        let rolePrivilege1 = Object.assign({}, this.state.rolePrivilege1);

        //Only for the big dropdown options
        if (MenuItem === "Home" || MenuItem === "Project"  || MenuItem === "Admin" || MenuItem === "Notifications") {
            this.changePermissionColumn(MenuItem, colIndex);
			return;
        }

        const header = this.getHeader(colIndex);
        let headersToCheck = [header];

        try {
            rolePrivilege1[MenuItem][header] = !this.state.rolePrivilege1[MenuItem][header];

            const isRepositoryItem = MenuItem === "Workflow" || MenuItem === "Field Repository" || MenuItem === "Settings Editor";

            if (isRepositoryItem) {
                if (rolePrivilege1[MenuItem][header]) {
                    if (header === 'Edit') {
                        rolePrivilege1[MenuItem]['View'] = true;
                        rolePrivilege1[MenuItem]['Detail'] = true;
                        if (!headersToCheck.includes('View')) headersToCheck.push('View');
                        if (!headersToCheck.includes('Detail')) headersToCheck.push('Detail');
                    }
                    else if (header === 'Add' || header === 'Detail' || header === 'Delete') {
                        rolePrivilege1[MenuItem]['View'] = true;
                        if (!headersToCheck.includes('View')) headersToCheck.push('View');
                    }
                } else {
                    if (header === 'Edit') {
                        if (!headersToCheck.includes('Detail')) headersToCheck.push('Detail');
                    }
                    if (header === 'View') {
                        rolePrivilege1[MenuItem]['Add'] = false;
                        rolePrivilege1[MenuItem]['Edit'] = false;
                        rolePrivilege1[MenuItem]['Detail'] = false;
                        rolePrivilege1[MenuItem]['Delete'] = false;
                        if (!headersToCheck.includes('Add')) headersToCheck.push('Add');
                        if (!headersToCheck.includes('Edit')) headersToCheck.push('Edit');
                        if (!headersToCheck.includes('Detail')) headersToCheck.push('Detail');
                        if (!headersToCheck.includes('Delete')) headersToCheck.push('Delete');
                    }
                }
            } else if (header !== 'View') {
                rolePrivilege1[MenuItem]['View'] = rolePrivilege1[MenuItem][header] ? true : rolePrivilege1[MenuItem]['View'];
                headersToCheck.push('View');
            }
        } catch {
            this.fixRolePrivileges();
        }

        this.setState({rolePrivilege1: rolePrivilege1});
        this.verifyTopic(rolePrivilege1,headersToCheck);
        this.verifyColumns(rolePrivilege1, headersToCheck);
    }

    getPermission = (MenuItem, colIndex) => {
        try {
            switch(colIndex){
                case 0:
                    return this.state.rolePrivilege1[MenuItem]['View'];
                case 1:
                    return this.state.rolePrivilege1[MenuItem]['Edit'];
                case 2:
                    return this.state.rolePrivilege1[MenuItem]['Add'];
                case 3:
                    return this.state.rolePrivilege1[MenuItem]['Delete'];
                case 4:
                    return this.state.rolePrivilege1[MenuItem]['Detail'];
                default:
                    return false;
            }
        } catch {
            this.fixRolePrivileges();
        }
    }

    getRoleRowByName = (roleName) => {
        return this.state.rolePrivilege.find((row) => row.MenuItem === roleName);
    }

    verifyColumns = (roleData,headers) => {
        let newColumns = Object.assign({},this.state.columns);

        headers.forEach((header)=> {
            const subHeaderItems = this.getSubHeaders(header);
            let selectedCategories = 0;

            subHeaderItems.forEach((individualRow) => {
                if (roleData[individualRow][header])selectedCategories++;
            })

            //If all categories selected, then set to 1, if at least one selected, set to 0, otherwise leave as -1
            if (selectedCategories === subHeaderItems.length){
                newColumns[header] = 1;
            } else if (selectedCategories > 0){
                newColumns[header] = 0;
            } else {
                newColumns[header] = -1;
            }
        })

        this.setState({ columns: newColumns })
    }

    //Verifies the topic headers (Projects, Tasks, Admin, Notifications)
    //roleData is current role data
    //headers are the topmost headers (View, admin)
    verifyTopic = (roleData, headers) =>{
        const topics = ['Home', 'Project', 'Admin', 'Notifications'];
        let newTopics = Object.assign({}, this.state.topics);
        let newRoleData = Object.assign({}, roleData);

        topics.forEach((topic) => {
            if (!roleData.hasOwnProperty(topic))return;

            headers.forEach((header) => {
                if (!roleData[topic].hasOwnProperty(header)) return;

                let selectedItems = 0;
                const subItems = this.getSubItems(header,topic);

                subItems.forEach((subItem) => {
                    roleData[subItem][header] && selectedItems++;
                })

                if(selectedItems === subItems.length){
                    newTopics[header][topic] = 1;
                    newRoleData[topic][header] = true;
                } else if (selectedItems > 0){
                    newTopics[header][topic] = 0;
                    newRoleData[topic][header] = true;
                } else {
                    newTopics[header][topic] = -1;
                    newRoleData[topic][header] = false;
                }
            })

        })
        this.setState({rolePrivilege1: newRoleData});
        this.setState({topics: newTopics});
    }

    checkColumn = (header) => {
        if(!this.state.columns.hasOwnProperty(header)) return;

        let rolePrivilege1 = Object.assign({}, this.state.rolePrivilege1);
        const prevValue = this.state.columns[header];
        let newItemValue = false;
        let headersToCheck = [header];

        if(prevValue === 0 || prevValue === 1) newItemValue = false;
        else if (prevValue === -1) newItemValue = true;

        const allSubItems = this.getSubHeaders(header);

        try {
            if (header !== 'View' && newItemValue === true) {
                headersToCheck.push('View');
                allSubItems.forEach((subItem) => {
                    rolePrivilege1[subItem]['View'] = true;
                })
            }

            allSubItems.forEach((subItem) => {
                rolePrivilege1[subItem][header] = newItemValue;
            })
        } catch {
            this.fixRolePrivileges();
        }

        this.setState({rolePrivilege1: rolePrivilege1 });
        this.verifyTopic(rolePrivilege1,headersToCheck);
        this.verifyColumns(rolePrivilege1, headersToCheck);
    }

    displayAlert() {
        window.setTimeout(() => {
            this.setState({showAlert: false});
        }, 5000);

        return (
            <Alert show={this.state.showAlert} onClose={() => this.setState({showAlert: false})} variant={this.state.alertVariant} dismissible>
                <Alert.Heading>{this.state.alertAction}</Alert.Heading>
                <p>{this.state.alertMessage}</p>
            </Alert>
        )
    }

    displayApprovalButton = (buttonText) =>{
        return(
            <Button className = 'btn-wide' onClick = {this.resetPage}>
                {buttonText}
            </Button>
        );
    }

    displayNegativeButton = (buttonText) => {
        return(
            <Button className = 'btn-outlined btn-wide' onClick = {() => this.setState({ showSuccessPopup: false, showCancelPopup: false })}>
                {buttonText}
            </Button>
        );
    }

    resetPage = () => {
        this.setState({
            roles: [],
            currRole: undefined,
            rolePrivilege: undefined,
            rolePrivilege1: undefined,
            showSuccessPopup:false,
            showCancelPopup: false,
        });
        this.loadRolesForDepartment(this.state.currDepartment);
    }

    doesSubDepartmentExist = () => {
        return this.state?.rolePrivilege?.some(item => item.MenuItem === "Sub-Department");
    }

    isRepositoryCheckboxDisabled = (menuItem, permission) => {
        const myRoleIsSuperAdmin = this.props.currentUser?.isSuperAdminRole;
        const myRoleIsAdmin = this.props.currentUser?.isAdminRole || (!myRoleIsSuperAdmin && this.props.currentUser);
        const configuringRoleIsSuperAdmin = this.state.isRoleSuperAdmin;

        const rolePrivilegeData = this.state.rolePrivilege1?.[menuItem];

        switch (permission) {
            case "View":
                if (rolePrivilegeData?.Add || rolePrivilegeData?.Edit || rolePrivilegeData?.Detail || rolePrivilegeData?.Delete) {
                    return true;
                }
 
                if (myRoleIsAdmin && !myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                    return true;
                }

                if (myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                    return false;
                }

                return false;

            case "Add":
            case "Edit":
                if (myRoleIsAdmin && !myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                    return true;
                }

                if (myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                    return false;
                }

                return false;

            case "Detail":
                if (rolePrivilegeData?.Edit) {
                    return true;
                }
                
                if (myRoleIsAdmin && !myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                    return true;
                }
                
                if (myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                    return false;
                }
                
                return false;

            case "Delete":
                if (myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                    return false;
                }
                
                return true;

            default:
                return false;
        }
    }

    isRepositoryCheckboxCheckedByDefault = (menuItem, permission) => {
        const configuringRoleIsSuperAdmin = this.state.isRoleSuperAdmin;

        if (this.state.rolePrivilege1?.[menuItem] !== undefined) {
            return this.state.rolePrivilege1[menuItem][permission] || false;
        }

        return configuringRoleIsSuperAdmin && (permission === "View" || permission === "Add" || permission === "Edit" || permission === "Detail");
    }

    getRepositoryCheckboxTooltip = (menuItem, permission) => {
        const myRoleIsSuperAdmin = this.props.currentUser?.isSuperAdminRole;
        const myRoleIsAdmin = this.props.currentUser?.isAdminRole || (!myRoleIsSuperAdmin && this.props.currentUser);
        const configuringRoleIsSuperAdmin = this.state.isRoleSuperAdmin;
        const rolePrivilegeData = this.state.rolePrivilege1?.[menuItem];

        if (permission === "View") {
            if (rolePrivilegeData?.Add || rolePrivilegeData?.Edit || rolePrivilegeData?.Detail || rolePrivilegeData?.Delete) {
                const enabledPermissions = [];
                if (rolePrivilegeData?.Edit) enabledPermissions.push("Edit");
                if (rolePrivilegeData?.Add) enabledPermissions.push("Add");
                if (rolePrivilegeData?.Detail) enabledPermissions.push("Detail");
                if (rolePrivilegeData?.Delete) enabledPermissions.push("Delete");
                return `View is required when ${enabledPermissions.join(", ")} is enabled`;
            }
            
            if (myRoleIsAdmin && !myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                return "Cannot modify - Admin configuring Super Admin role";
            }
        }

        if (permission === "Detail") {
            if (rolePrivilegeData?.Edit) {
                return "Detail is required when Edit is enabled";
            }
            
            if (myRoleIsAdmin && !myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                return "Cannot modify - Admin configuring Super Admin role";
            }
        }

        if (permission === "Add" || permission === "Edit") {
            if (myRoleIsAdmin && !myRoleIsSuperAdmin && configuringRoleIsSuperAdmin) {
                return "Cannot modify - Admin configuring Super Admin role";
            }
        }

        if (permission === "Delete") {
            if (!(myRoleIsSuperAdmin && configuringRoleIsSuperAdmin)) {
                return "Only Super Admin can change another Super Admin role's delete permission";
            }
        }

        return null;
    }

    render = () => {
        const subDepartmentExist = this.doesSubDepartmentExist();
        return (
            <div className="admin-role-privilege-page">
                { this.state.showAlert && this.displayAlert() }
                <ActionPopup
                    mainText={'Your changes have been saved successfully.'}
                    show={this.state.showSuccessPopup}
                    header={"Save Confirmation"}
                    icon = {SuccessIcon}
                    acceptButton={this.displayApprovalButton('OK')}
                    onHide={this.resetPage}
                />
                <ActionPopup
                    mainText={`Are you sure you want to cancel?\nYour changes will not be saved.`}
                    show={this.state.showCancelPopup}
                    header={"Cancel Confirmation"}
                    icon = {WarningIcon}
                    acceptButton={this.displayApprovalButton('Yes')}
                    rejectButton = {this.displayNegativeButton('No')}
                    onHide = {()=> this.setState({showCancelPopup:false})}
                />
                {
                    this.props.permission &&
                    <React.Fragment>
                        <Form className="admin-role-dropdowns">
                            {   this.props.currentUser.isSuperAdminRole &&
                                <Form.Group className="left-dropdown-section">
                                    <Form.Label className='dropdown-title'>Department <span style = {{color:"red"}}> * </span> </Form.Label>
                                    <Dropdown
                                        values={this.state.departments && this.state.departments.map(department => {
                                            return { id: department.Id, name: department.Name + (department.Active ? "" : " [Inactive]"), disabled: !department.Active }
                                        })}
                                        dropdownButtonText={"Select a Department"}
                                        onSelect={(selectedValue) => {
                                            this.changeDepartment(selectedValue)
                                        }}
                                        currentSelected={this.state.currDepartment}
                                    />
                                </Form.Group>
                            }
                            {   this.state.isDepartmentSelected &&
                                <Form.Group className="right-dropdown-section">
                                    <Form.Label className = 'dropdown-title'>Role <span style = {{color:"red"}}> * </span></Form.Label>
                                    <Dropdown
                                        values={this.state.roles && this.state.roles.map(role => {
                                            return { id: role.Id, name: role.Name, disabled: !role.Active }
                                        })}
                                        dropdownButtonText={"Select a Role"}
                                        onSelect={(selectedValue) => this.changeRole(selectedValue)}
                                        currentSelected={this.state.currRole}
                                    />
                                </Form.Group>
                            }
                        </Form>
                        <div className="role-privllege-table">
                            {   this.state.loaded  &&
                                <div className = 'pulse-loader'>
                                    <PulseLoader/>
                                </div>
                            }
                            {   this.state.rolePrivilege &&
                                <React.Fragment>
                                    <Table className = 'privileges-table' key={JSON.stringify(this.state.currRole)}>
                                        <thead>
                                            <tr className="header-row">
                                                <th className="title-column">
                                                    <div className = 'topic-title'>
                                                        <tr className="header-row">MENU ITEM</tr>
                                                    </div>
                                                </th>
                                                <th className="view-permission-column permission-column">
                                                    <div className='view-title'><tr className="header-row">VIEW</tr></div>
                                                    <tr className="header-row">
                                                        <Form.Check
                                                        className= {`${this.state.columns.View ===0 && 'big-header-check'}`}
                                                        label=""
                                                        id='VIEWID'
                                                        checked={this.state.columns.View === 1 || this.state.columns.View === 0}
                                                        onChange={() => {this.checkColumn("View")}}
                                                        />
                                                    </tr>
                                                </th>
                                                <th className="edit-permission-column permission-column">
                                                    <div className='edit-title'><tr className="header-row">EDIT</tr></div>
                                                    <tr className="header-row">
                                                        { /*<IndeterminateCheckbox checkedState = {this.state.columns.Edit} onChange={() => {this.checkColumn("Edit")}} columnID={'EDITID'}/> */}
                                                        <Form.Check
                                                        className= {`${this.state.columns.Edit ===0 && 'big-header-check'}`}
                                                        label=""
                                                        id='EDITID'
                                                        checked={this.state.columns.Edit === 1 || this.state.columns.Edit === 0}
                                                        onChange={() => {this.checkColumn("Edit")}}
                                                        />
                                                    </tr>
                                                </th>
                                                <th className="add-permission-column permission-column">
                                                    <div className='add-title'><tr className="header-row">ADD</tr></div>
                                                    <tr className="header-row">
                                                        {/*<IndeterminateCheckbox checkedState = {this.state.columns.Add} onChange={() => {this.checkColumn("Add")}} columnID={'ADDID'}/> */}
                                                        <Form.Check
                                                        className= {`${this.state.columns.Add ===0 && 'big-header-check'}`}
                                                        label=""
                                                        id='ADDID'
                                                        checked={this.state.columns.Add === 1 || this.state.columns.Add === 0}
                                                        onChange={() => {this.checkColumn("Add")}}
                                                        />
                                                    </tr>
                                                </th>
                                                <th className="delete-permission-column permission-column">
                                                    <div className='delete-title'><tr className="header-row">DELETE/ARCHIVE</tr></div>
                                                    <tr className="header-row">
                                                        {/*<IndeterminateCheckbox checkedState = {this.state.columns.Delete} onChange={() => {this.checkColumn("Delete")}} columnID={'DELETEID'}/> */}
                                                        <Form.Check
                                                        className= {`${this.state.columns.Delete ===0 && 'big-header-check'}`}
                                                        label=""
                                                        id='DELETEID'
                                                        checked={this.state.columns.Delete === 1 || this.state.columns.Delete === 0}
                                                        onChange={() => {this.checkColumn("Delete")}}
                                                        />
                                                    </tr>
                                                </th>
                                                <th className="detail-permission-column permission-column">
                                                    <div className='detail-title'><tr className="header-row">DETAIL</tr></div>
                                                    <tr className="header-row">
                                                        { /*<IndeterminateCheckbox checkedState = {this.state.columns.Detail} onChange={() => {this.checkColumn("Detail")}} columnID={'DETAILID'}/> */}
                                                        <Form.Check
                                                        className= {`${this.state.columns.Detail ===0 && 'big-header-check'}`}
                                                        label=""
                                                        id='DETAILID'
                                                        checked={this.state.columns.Detail === 1 || this.state.columns.Detail === 0}
                                                        onChange={() => {this.checkColumn("Detail")}}
                                                        />
                                                    </tr>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <>
                                                <tr className={"dashboard-row"}>
                                                    <td className="name-column">Dashboard</td>
                                                    {
                                                        ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                            return (
                                                                column === "View" ?
                                                                <td key={column} className={column + "-permission-column  permission-column"}>
                                                                    <Form.Check className="checkbox"
                                                                        type={'checkbox'}
                                                                        inline checked={this.state.rolePrivilege1['Dashboard'] !== undefined ? this.getPermission("Dashboard", permissionIndex) : false}
                                                                        onChange={() => {this.state.rolePrivilege1['Dashboard'] !== undefined ?
                                                                            this.changePermission("Dashboard", permissionIndex)
                                                                        :
                                                                            this.createPermission("Dashboard", 16, permissionIndex)
                                                                        }}/>
                                                                </td>
                                                                : <td></td>
                                                            )
                                                        })
                                                    }
                                                </tr>
                                                <tr className={"search-row"}>
                                                    <td className="name-column">Search</td>
                                                    {
                                                        ["View", "Add", "Edit", "Delete", "Detail"].map((column, permissionIndex) => {
                                                            return (
                                                                column === "View" ?
                                                                <td key={column} className={column + "-permission-column permission-column"}>
                                                                    <Form.Check className="checkbox"
                                                                        type={'checkbox'}
                                                                        inline checked={this.state.rolePrivilege1['Search'] !== undefined ? this.getPermission("Search", permissionIndex) : false}
                                                                        onChange={() => {this.state.rolePrivilege1['Search'] !== undefined ?
                                                                            this.changePermission("Search", permissionIndex)
                                                                        :
                                                                            this.createPermission("Search", 26, permissionIndex)
                                                                        }}
                                                                    />
                                                                </td>
                                                                : <td></td>
                                                            )
                                                        })
                                                    }
                                                </tr>
                                                <tr className={"updated-documents-row"}>
                                                    <td className="name-column">Updated Document</td>
                                                    {
                                                        ["View", "Add", "Edit", "Delete", "Detail"].map((column, permissionIndex) => {
                                                            return (
                                                                column === "View" ?
                                                                <td key={column} className={column + "-permission-column permission-column"}>
                                                                    <Form.Check className="checkbox"
                                                                        type={'checkbox'}
                                                                        inline checked={this.state.rolePrivilege1['Updated Document'] !== undefined ? this.getPermission("Updated Document", permissionIndex) : false}
                                                                        onChange={() => {this.state.rolePrivilege1['Updated Document'] !== undefined ?
                                                                            this.changePermission("Updated Document", permissionIndex)
                                                                        :
                                                                            this.createPermission("Updated Document", 13, permissionIndex)
                                                                        }}
                                                                    />
                                                                </td>
                                                                : <td></td>
                                                            )
                                                        })
                                                    }
                                                </tr>
                                                <tr className={"home-row"}>
                                                    <td className="name-column">
                                                        <Button className="table-dropdown-btn"  onClick={() => {this.setState({tasksSubTabOpen: !this.state.tasksSubTabOpen})}}>
                                                            Tasks
                                                        </Button>
                                                    </td>
                                                    {
                                                        ["View", "Edit", "Add"].map((column, permissionIndex) => {
                                                            return (
                                                                <td key={column} className={column + "-permission-column  permission-column"}>
                                                                    <Form.Check
                                                                        className= {`${this.state.topics[column]['Home'] === 0 && 'big-header-check'}`}
                                                                        label=""
                                                                        id={column + 'HOME'}
                                                                        checked={this.state.topics[column]['Home'] === 1 || this.state.topics[column]['Home'] === 0}
                                                                        onChange={() => {
                                                                            this.state.rolePrivilege1['Home'] !== undefined
                                                                            ?   this.changePermission("Home", permissionIndex)
                                                                            :   this.createPermission("Home", 17, permissionIndex)
                                                                        }}
                                                                    />
                                                                </td>
                                                            )
                                                        })
                                                    }
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                {   this.state.tasksSubTabOpen && ["Task Management", "Document Collaboration"].map((rowType, rowIndex) => {
                                                        return (
                                                            <tr key={rowType} className={rowType + "-row sub-row"}>
                                                                <td className="name-column">{rowType !== 'Task Management' ? rowType : 'Standard Task' }</td>
                                                                {
                                                                    ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            column === "View" || column === "Edit" || column === "Add"
                                                                            ?   <td key={column} className={column + "-permission-column  permission-column"}>
                                                                                    <Form.Check
                                                                                        className="checkbox"
                                                                                        type={'checkbox'}
                                                                                        inline checked={this.state.rolePrivilege1[rowType] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                        onChange={() => {this.state.rolePrivilege1[rowType] !== undefined
                                                                                            ?   this.changePermission(rowType, permissionIndex)
                                                                                            :   this.createPermission(rowType, 18 + permissionIndex, permissionIndex)
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            :   <td></td>
                                                                        )
                                                                    })
                                                                }
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                <tr className={"projects-row"}>
                                                    <td className="name-column">
                                                        <Button className="table-dropdown-btn" onClick={() => {this.setState({projectsSubTabOpen: !this.state.projectsSubTabOpen})}}>
                                                            Projects
                                                        </Button>
                                                    </td>
                                                    {
                                                        ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                            return (
                                                                <td key={column} className={column + "-permission-column permission-column"}>
                                                                <Form.Check
                                                                    className= {`${this.state.topics[column]['Project'] === 0 && 'big-header-check'}`}
                                                                    label=""
                                                                    id={column + 'PROJECT'}
                                                                    checked={this.state.topics[column]['Project'] === 1 || this.state.topics[column]['Project'] === 0}
                                                                    onChange={() => {
                                                                        this.state.rolePrivilege1['Project'] !== undefined
                                                                        ?   this.changePermission('Project', permissionIndex)
                                                                        :   this.createPermission('Project', 5, permissionIndex)
                                                                    }}
                                                                    />
                                                                </td>
                                                            )
                                                        })
                                                    }
                                                </tr>
                                                {   this.state.projectsSubTabOpen && ["Active Projects", "Completed Projects", "Archived Projects", ...this.state.isRoleAdmin ? ["Projects within department"] : []].map((rowType, rowIndex) => {
                                                        return (
                                                            <tr key={rowType} className={rowType + "-row sub-row"}>
                                                                <td className="name-column">{rowType}</td>
                                                                {
                                                                    rowType === "Active Projects"
                                                                    ?   ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                            return (
                                                                                <td key={column} className={column + "-permission-column permission-column"}>
                                                                                    <Form.Check className="checkbox"
                                                                                        type={'checkbox'}
                                                                                        inline checked={this.state.rolePrivilege1['Projects'] !== undefined ? this.getPermission("Projects", permissionIndex) : false}
                                                                                        onChange={() => {
                                                                                            this.state.rolePrivilege1['Projects'] !== undefined
                                                                                            ?   this.changePermission("Projects", permissionIndex)
                                                                                            :   this.createPermission("Projects", 20, permissionIndex)
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            )
                                                                        })
                                                                    :   rowType === "Completed Projects"
                                                                        ?   ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                                return (
                                                                                    <td key={column} className={column + "-permission-column permission-column"}>
                                                                                        <Form.Check className="checkbox"
                                                                                            type={'checkbox'}
                                                                                            inline checked={this.state.rolePrivilege1['Completed Projects'] !== undefined ? this.getPermission("Completed Projects", permissionIndex) : false}
                                                                                            onChange={() => {
                                                                                                this.state.rolePrivilege1['Completed Projects'] !== undefined
                                                                                                ?   this.changePermission("Completed Projects", permissionIndex)
                                                                                                :   this.createPermission("Completed Projects", 11, permissionIndex)
                                                                                            }}
                                                                                        />
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        :   rowType === "Archived Projects"
                                                                            ?   ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                                    return (
                                                                                        <td key={column} className={column + "-permission-column permission-column"}>
                                                                                            <Form.Check className="checkbox"
                                                                                                type={'checkbox'}
                                                                                                inline checked={this.state.rolePrivilege1['Archived Projects'] !== undefined ? this.getPermission("Archived Projects", permissionIndex) : false}
                                                                                                onChange={() => {
                                                                                                    this.state.rolePrivilege1['Archived Projects'] !== undefined
                                                                                                    ?   this.changePermission("Archived Projects", permissionIndex)
                                                                                                    :   this.createPermission("Archived Projects", 6, permissionIndex)
                                                                                                }}
                                                                                            />
                                                                                        </td>
                                                                                    )
                                                                                })
                                                                            :   ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                                    return (
                                                                                        column === "View"
                                                                                        ?   <td key={column} className={column + "-permission-column permission-column"}>
                                                                                                <Form.Check className="checkbox"
                                                                                                    type={'checkbox'} /*inline checked={this.getPermission(6, permissionIndex)}
                                                                                                    onChange={() => {this.changePermission(6, permissionIndex)}}*/
                                                                                                    inline checked={this.state.rolePrivilege1['Projects within department'] !== undefined ? this.getPermission("Projects within department", permissionIndex) : false}
                                                                                                    onChange={() => {
                                                                                                        this.state.rolePrivilege1['Projects within department'] !== undefined
                                                                                                        ?   this.changePermission("Projects within department", permissionIndex)
                                                                                                        :   this.createPermission("Projects within department", 25, permissionIndex)
                                                                                                    }}
                                                                                                />
                                                                                            </td>
                                                                                        :   <td></td>
                                                                                    )
                                                                                })
                                                                }
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                {   (this.state.isRoleSuperAdmin || this.state.isRoleAdmin) &&
                                                    <tr className={"admin-row"}>
                                                        <td className="name-column">
                                                            <Button className="table-dropdown-btn" onClick={() => {
                                                                if(this.state.adminSubTabOpen) {
                                                                    this.setState({notificationSubTabOpen: false});
                                                                }
                                                                this.setState({adminSubTabOpen: !this.state.adminSubTabOpen
                                                                })}}>
                                                                Admin
                                                            </Button>
                                                        </td>
                                                        {
                                                            ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                return (
                                                                    <td key={column} className={column + "-permission-column permission-column"}>
                                                                        <Form.Check
                                                                            className= {`${this.state.topics[column]['Admin'] === 0 && 'big-header-check'}`}
                                                                            label=""
                                                                            id={column + 'ADMIN'}
                                                                            checked={this.state.topics[column]['Admin'] === 1 || this.state.topics[column]['Admin'] === 0}
                                                                            onChange={() => {
                                                                                this.state.rolePrivilege1['Admin'] !== undefined
                                                                                ?   this.changePermission("Admin", permissionIndex, false)
                                                                                :   this.createPermission("Admin", 15, permissionIndex)
                                                                            }}
                                                                        />
                                                                    </td>
                                                                )
                                                            })
                                                        }
                                                    </tr>
                                                }
                                                {   this.state.adminSubTabOpen &&
                                                    ["User", "Group", "Role", "Role Privileges", "Department", "Sub-Department", "Log Activity", "Notifications", ...this.state.notificationSubTabOpen ? ["Email Notifications", "Platform Notifications"] : [], "Templates", "Task Types", "Workflow", "Field Repository", "Settings Editor"].map((rowType, rowIndex) => {
                                                        return (
                                                            <tr key={rowType} className={rowType + "-row sub-row"}>
                                                                <td className="name-column">
                                                                    {   rowType === 'Notifications'
                                                                        ?   <Button className="table-dropdown-btn" onClick={() => {this.setState({notificationSubTabOpen: !this.state.notificationSubTabOpen})}}>
                                                                                {rowType}
                                                                            </Button>
                                                                        :   rowType
                                                                    }
                                                                </td>
                                                                {   rowType === "Role Privileges" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            column === "View" || column === "Edit"
                                                                            ?   <td key={column} className={column + "-permission-column permission-column"}>
                                                                                    <Form.Check className="checkbox"
                                                                                        checked={this.state.rolePrivilege1['Role Privileges'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                        onChange={() => {
                                                                                            this.state.rolePrivilege1['Role Privileges'] !== undefined
                                                                                            ?   this.changePermission(rowType, permissionIndex)
                                                                                            :   this.createPermission(rowType, 9, permissionIndex)
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            :   <td></td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Notifications" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            column === "View" || column === "Edit"
                                                                            ?   <td key={column} className={column + "-permission-column permission-column"}>
                                                                                    <Form.Check
                                                                                        className= {`${this.state.topics[column]['Notifications'] === 0 && 'big-header-check'}`}
                                                                                        label=""
                                                                                        id={column + 'NOTIFICATION'}
                                                                                        checked={this.state.topics[column]['Notifications'] === 1 || this.state.topics[column]['Notifications'] === 0}
                                                                                        onChange={() => {
                                                                                            this.state.rolePrivilege1['Notifications'] !== undefined
                                                                                            ?   this.changePermission(rowType, permissionIndex, false)
                                                                                            :   this.createPermission(rowType, 21, permissionIndex, false)
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            :   <td></td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Log Activity" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            column === "View" || column === "Detail"
                                                                            ?   <td key={column} className={column + "-permission-column permission-column"}>
                                                                                    <Form.Check className="checkbox"
                                                                                        disabled={!this.props.currentUser?.isSuperAdminRole}
                                                                                        type={'checkbox'}
                                                                                        checked={this.state.rolePrivilege1['Log Activity'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                        onChange={() => {
                                                                                            this.state.rolePrivilege1['Log Activity'] !== undefined
                                                                                            ?   this.changePermission(rowType, permissionIndex)
                                                                                            :   this.createPermission(rowType, 12, permissionIndex)
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            :   <td></td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "User" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                <Form.Check className="checkbox"
                                                                                    type={'checkbox'}
                                                                                    checked={this.state.rolePrivilege1['User'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                    onChange={() => {
                                                                                        this.state.rolePrivilege1['User'] !== undefined
                                                                                        ?   this.changePermission(rowType, permissionIndex)
                                                                                        :   this.createPermission(rowType, 7, permissionIndex)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Group" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                        <td key={column} className={column + "-permission-column permission-column"}>
                                                                            <Form.Check className="checkbox"
                                                                                type={'checkbox'}
                                                                                checked={this.state.rolePrivilege1['Group'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                onChange={() => {
                                                                                    this.state.rolePrivilege1['Group'] !== undefined
                                                                                    ?   this.changePermission(rowType, permissionIndex)
                                                                                    :   this.createPermission(rowType, 24, permissionIndex)
                                                                                }}
                                                                            />
                                                                        </td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Role" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                <Form.Check className="checkbox"
                                                                                    disabled={!this.props.currentUser?.isSuperAdminRole}
                                                                                    type={'checkbox'}
                                                                                    checked={this.state.rolePrivilege1['Role'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                    onChange={() =>
                                                                                        {this.state.rolePrivilege1['Role'] !== undefined
                                                                                        ?   this.changePermission(rowType, permissionIndex)
                                                                                        :   this.createPermission(rowType, 8, permissionIndex)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Department" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                <Form.Check className="checkbox"
                                                                                    disabled={!this.props.currentUser?.isSuperAdminRole}
                                                                                    type={'checkbox'}
                                                                                    checked={this.state.rolePrivilege1['Department'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                    onChange={() => {
                                                                                        this.state.rolePrivilege1['Department'] !== undefined
                                                                                        ?   this.changePermission(rowType, permissionIndex)
                                                                                        :   this.createPermission(rowType, 10, permissionIndex)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                                {  rowType === "Sub-Department" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return  (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                <Form.Check className="checkbox"
                                                                                     disabled={!subDepartmentExist || !this.props.currentUser?.isSuperAdminRole}
                                                                                    type={'checkbox'}
                                                                                    checked={this.state.rolePrivilege1['Sub-Department'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                    onChange={() => {
                                                                                        this.state.rolePrivilege1['Sub-Department'] !== undefined
                                                                                        ?   this.changePermission(rowType, permissionIndex)
                                                                                        :   this.createPermission(rowType, 29, permissionIndex)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                                { rowType === "Workflow" &&
                                                                    ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        const isDisabled = this.isRepositoryCheckboxDisabled(rowType, column);
                                                                        const tooltipText = isDisabled ? this.getRepositoryCheckboxTooltip(rowType, column) : null;
                                                                        
                                                                        const checkbox = (
                                                                            <Form.Check
                                                                                className="checkbox"
                                                                                type="checkbox"
                                                                                disabled={isDisabled}
                                                                                checked={
                                                                                    this.state.rolePrivilege1['Workflow'] === undefined
                                                                                        ? this.isRepositoryCheckboxCheckedByDefault(rowType, column)
                                                                                        : this.getPermission(rowType, permissionIndex)
                                                                                }
                                                                                onChange={() => {
                                                                                    this.state.rolePrivilege1['Workflow'] === undefined
                                                                                        ? this.createPermission(rowType, 30, permissionIndex)
                                                                                        : this.changePermission(rowType, permissionIndex)
                                                                                }}
                                                                            />
                                                                        );

                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                {tooltipText ? (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip id={`tooltip-workflow-${column}`} show={false}>{tooltipText}</Tooltip>}
                                                                                    >
                                                                                        <div>{checkbox}</div>
                                                                                    </OverlayTrigger>
                                                                                ) : (
                                                                                    checkbox
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })
                                                                }
                                                                { rowType === "Field Repository" &&
                                                                    ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        const isDisabled = this.isRepositoryCheckboxDisabled(rowType, column);
                                                                        const tooltipText = isDisabled ? this.getRepositoryCheckboxTooltip(rowType, column) : null;
                                                                        
                                                                        const checkbox = (
                                                                            <Form.Check
                                                                                className="checkbox"
                                                                                type="checkbox"
                                                                                disabled={isDisabled}
                                                                                checked={
                                                                                    this.state.rolePrivilege1['Field Repository'] === undefined
                                                                                        ? this.isRepositoryCheckboxCheckedByDefault(rowType, column)
                                                                                        : this.getPermission(rowType, permissionIndex)
                                                                                }
                                                                                onChange={() => {
                                                                                    this.state.rolePrivilege1['Field Repository'] === undefined
                                                                                        ? this.createPermission(rowType, 31, permissionIndex)
                                                                                        : this.changePermission(rowType, permissionIndex)
                                                                                }}
                                                                            />
                                                                        );

                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                {tooltipText ? (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip id={`tooltip-field-repo-${column}`}
                                                                                        >{tooltipText}</Tooltip>}
                                                                                    >
                                                                                        <div>{checkbox}</div>
                                                                                    </OverlayTrigger>
                                                                                ) : (
                                                                                    checkbox
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })
                                                                }
                                                                { rowType === "Settings Editor" &&
                                                                    ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        const isDisabled = this.isRepositoryCheckboxDisabled(rowType, column);
                                                                        const tooltipText = isDisabled ? this.getRepositoryCheckboxTooltip(rowType, column) : null;
                                                                        
                                                                        const checkbox = (
                                                                            <Form.Check
                                                                                className="checkbox"
                                                                                type="checkbox"
                                                                                disabled={isDisabled}
                                                                                checked={
                                                                                    this.state.rolePrivilege1['Settings Editor'] === undefined
                                                                                        ? this.isRepositoryCheckboxCheckedByDefault(rowType, column)
                                                                                        : this.getPermission(rowType, permissionIndex)
                                                                                }
                                                                                onChange={() => {
                                                                                    this.state.rolePrivilege1['Settings Editor'] === undefined
                                                                                        ? this.createPermission(rowType, 32, permissionIndex)
                                                                                        : this.changePermission(rowType, permissionIndex)
                                                                                }}
                                                                            />
                                                                        );

                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                {tooltipText ? (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip id={`tooltip-settings-editor-${column}`}>{tooltipText}</Tooltip>}
                                                                                    >
                                                                                        <div>{checkbox}</div>
                                                                                    </OverlayTrigger>
                                                                                ) : (
                                                                                    checkbox
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })
                                                                }

                                                                {   rowType === "Email Notifications" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return  (
                                                                            column === "View" || column === "Edit"
                                                                            ?   <td key={column} className={column + "-permission-column  permission-column"}>
                                                                                    <Form.Check className="checkbox"
                                                                                        type={'checkbox'}
                                                                                        inline checked={this.state.rolePrivilege1['Email Notifications'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                        onChange={() => {
                                                                                            this.state.rolePrivilege1['Email Notifications'] !== undefined
                                                                                            ?   this.changePermission(rowType, permissionIndex)
                                                                                            :   this.createPermission(rowType, 22, permissionIndex)
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            :   <td></td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Platform Notifications" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            column === "View" || column === "Edit"
                                                                            ?   <td key={column} className={column + "-permission-column  permission-column"}>
                                                                                    <Form.Check className="checkbox"
                                                                                        type={'checkbox'}
                                                                                        inline checked={this.state.rolePrivilege1['Platform Notifications'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                        onChange={() => {
                                                                                            this.state.rolePrivilege1['Platform Notifications'] !== undefined
                                                                                            ?   this.changePermission(rowType, permissionIndex)
                                                                                            :   this.createPermission(rowType, 23, permissionIndex)
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            :   <td></td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Templates" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                <Form.Check className="checkbox"
                                                                                    type={'checkbox'}
                                                                                    checked={this.state.rolePrivilege1['Templates'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                    onChange={() => {
                                                                                        this.state.rolePrivilege1['Templates'] !== undefined
                                                                                        ?   this.changePermission(rowType, permissionIndex)
                                                                                        :   this.createPermission(rowType, 27, permissionIndex)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                                {   rowType === "Task Types" && ["View", "Edit", "Add", "Delete", "Detail"].map((column, permissionIndex) => {
                                                                        return (
                                                                            <td key={column} className={column + "-permission-column permission-column"}>
                                                                                <Form.Check className="checkbox"
                                                                                    type={'checkbox'}
                                                                                    checked={this.state.rolePrivilege1['Task Types'] !== undefined ? this.getPermission(rowType, permissionIndex) : false}
                                                                                    onChange={() => {
                                                                                        this.state.rolePrivilege1['Task Types'] !== undefined
                                                                                        ?   this.changePermission(rowType, permissionIndex)
                                                                                        :   this.createPermission(rowType, 28, permissionIndex)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </>
                                        </tbody>
                                    </Table>
                                    <div key="btn-container">
                                        <ButtonToolbar className="btn-container form-buttons">
                                            <Button
                                                disabled={this.state.isSubmitting}
                                                className = "btn-outlined btn-wide"
                                                onClick = {() => this.setState({showCancelPopup: true})}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                disabled={this.state.isSubmitting}
                                                className="btn-wide"
                                                onClick={() => {this.onSubmit()}}
                                            >
                                                Save
                                            </Button>
                                        </ButtonToolbar>
                                    </div>
                                </React.Fragment>
                            }
                            {   !this.state.rolePrivilege &&
                                <PlaceholderEmptyScreen
                                    headerText="Select a role to get started"
                                    bottomImage={placeholderImage}
                                    altImageText="Select a role clicking the dropdown"
                                />
                            }
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

AdminRolePrivilegePage.contextType = LoginContext;
export default AdminRolePrivilegePage;
